import { render, staticRenderFns } from "./PromotionOrder.vue?vue&type=template&id=77fb231e&scoped=true"
import script from "./PromotionOrder.vue?vue&type=script&lang=js"
export * from "./PromotionOrder.vue?vue&type=script&lang=js"
import style0 from "./PromotionOrder.vue?vue&type=style&index=0&id=77fb231e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb231e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77fb231e')) {
      api.createRecord('77fb231e', component.options)
    } else {
      api.reload('77fb231e', component.options)
    }
    module.hot.accept("./PromotionOrder.vue?vue&type=template&id=77fb231e&scoped=true", function () {
      api.rerender('77fb231e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/PromotionOrder.vue"
export default component.exports